import React, { useEffect, useRef, useState } from 'react';

import { Stack, Typography } from '@mui/material';

import MasonrySection from '../../common/ui/qvshop/components/MasonrySection';
import ProductCard from '../../common/ui/qvshop/components/ProductCard';
import ProductCardSkeleton from '../../common/ui/qvshop/components/ProductCardSkeleton';

export default function ExtraArticles(props) {
    const { title, articles, loading, hideAddToCartButton, breakpointCols } = props;
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        if (!containerRef.current || typeof ResizeObserver === 'undefined') {
            return;
        }

        const resizeObserver = new ResizeObserver(([entry]) => {
            setContainerWidth(entry.contentRect.width);
        });

        resizeObserver.observe(containerRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const dynamicBreakpointCols = containerWidth >= 900 ? 3 : (containerWidth >= 590 ? 2 : 1);

    return (
        <Stack ref={containerRef} direction='column' spacing={2} width="100%">
            <Typography variant="h6">
                {title}
            </Typography>
            <MasonrySection breakpointCols={breakpointCols ?? dynamicBreakpointCols ?? {
                    default: 3,
                    720: 1,
                    1050: 2,
                    1380: 3,
                }}
                items={ Object.values(articles) }
                loading={loading}
                skeleton={ ProductCardSkeleton } 
                card={ ProductCard } 
                hideAddToCartButton={ hideAddToCartButton }
                />
        </Stack>
    );
};
